import { _ as _applyDecoratedDescriptor } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import { sanitizeHtml } from 'beebee-helper/helpers/safe-string';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<span class=\'my-radiobutton {{if @disabled \"disabled\"}}\' ...attributes>\n  <div\n    class=\'checkbox checkbox-adv {{if @disabled \"disabled\"}}\'\n    role=\'radio\'\n    aria-checked=\'{{if (is-equal @content @value) \"true\" \"false\"}}\'\n    aria-disabled=\'{{if @disabled \"true\" \"false\"}}\'\n    aria-labelledby=\'{{this.labelId}}\'\n    tabindex=\'{{if @disabled \"-1\" \"0\"}}\'\n    data-test-toggle-check\n    {{on \'click\' this.toggleCheck}}\n    {{on \'keydown\' this.handleKeydown}}\n  >\n    <div class=\'check {{if (is-equal @content @value) \"checked\"}}\'>\n      <FaIcon @icon=\'check\' class=\'checked-icon\' />\n    </div>\n\n    <span id={{this.labelId}}>\n      {{this.labelEscape}}\n      {{#if @required}}\n        <span class=\'required\'>{{t \'required\'}}</span>\n      {{/if}}\n    </span>\n  </div>\n</span>");

var _class;
let BbRadioComponent = (_class = class BbRadioComponent extends Component {
  get labelId() {
    return `radio-label-${guidFor(this)}`;
  }
  get labelEscape() {
    // Labels may intentionally contain markup (icons, <b>): sanitize, don't escape.
    return this.args.label ? sanitizeHtml(this.args.label) : '';
  }
  toggleCheck() {
    if (!this.args.disabled) {
      this.args.setContent?.(this.args.value);
      if (this.args.action) {
        this.args.action(this.args.value);
      }
    }
  }
  handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleCheck();
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "toggleCheck", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCheck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeydown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeydown"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbRadioComponent);

export { BbRadioComponent as default };
//# sourceMappingURL=bb-radio.js.map
